import { render, staticRenderFns } from "./ConfigAlertGitter.vue?vue&type=template&id=1115f7c5&scoped=true"
import script from "./ConfigAlertGitter.vue?vue&type=script&lang=js"
export * from "./ConfigAlertGitter.vue?vue&type=script&lang=js"
import style0 from "./ConfigAlertGitter.vue?vue&type=style&index=0&id=1115f7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115f7c5",
  null
  
)

export default component.exports